import { Collection, Token } from './types';

/**
 * https://www.figma.com/file/ulUeUVSNgLMAYaeH0nJxCI/Den---Foundations?type=design&node-id=1059-12046&mode=design&t=tZCslkWS49FsAr7k-4
 */
export const blur = new Collection({
  none: new Token('0px', 'blur-none'),
  sm: new Token('8px', 'blur-sm'),
  md: new Token('16px', 'blur-md'),
  lg: new Token('24px', 'blur-lg'),
});
